import { useMutation } from "@tanstack/react-query";
import instance from "../../service/instance";
import { UPLOADNEWMEMBERSFILE } from "../../service/api";

export const useUploadNewEnrollmentFile = (options = {}) => {
  return useMutation({
    mutationFn: async (formData) => {
      const { data } = await instance.post(
        UPLOADNEWMEMBERSFILE,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return data;
    },
    ...options,
  });
};
